import { useEffect } from 'react';

import { v4 } from 'uuid';

import { useGetTemplateConfig } from 'hooks/api/builder/mapTemplates/useGetTemplateConfig';
import useAxios from 'hooks/api/useAxios';
import { MapTemplate } from 'types/api/mapTemplate';

type UseDuplicateMapTemplateProps = {
    duplicateTemplate: (id: number) => void;
    error: boolean;
    loading: boolean;
    success: boolean;
};

export const useDuplicateMapTemplate = (): UseDuplicateMapTemplateProps => {
    const {
        getTemplate,
        error: configErr,
        loading: configLoading,
        success: configSuccess,
        config,
    } = useGetTemplateConfig();

    const [res, { rerun }] = useAxios<MapTemplate>(
        {
            url: '/api/builder/map/template/add/',
            method: 'POST',
            skipRequest: () => true,
            data: {
                name: `${config?.name} (Копия)`,
                uuid: v4(),
                config: {
                    ...config?.config,
                },
            },
        },
        [config?.name]
    );

    const error = res.type === 'error' || !!configErr;
    const loading = res.type === 'loading' || configLoading;
    const success = res.type === 'success' && configSuccess;

    const duplicateTemplate = (id: number): void => {
        getTemplate(id);
    };

    useEffect(() => {
        if (config) {
            rerun();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [config]);

    return { duplicateTemplate, error, loading, success };
};
